<template>
  <div>
    <p>Monitoring gives you real-time visibility into your NServiceBus system performance:</p>
    <ul>
      <li><strong>Overall Performance metrics</strong> - Understand how your endpoints are performing</li>
      <li><strong>Logical Endpoint Monitoring</strong> - View aggregated metrics across all instances of an endpoint</li>
      <li><strong>Physical Endpoint Monitoring</strong> - Drill down into individual endpoint instances for detailed metrics</li>
    </ul>
  </div>
</template>
